import {localStorageAvailable} from "./localStorage";



class Storage {

  private inMemory = new Map<string, string>()

  get = (k: string): string | null => {

    if (localStorageAvailable) {
      return localStorage.getItem(k)
    } else {
      return this.inMemory.get(k) ?? null
    }
  }

  set = (k: string, v: string) => {
    if (localStorageAvailable) {
      localStorage.setItem(k, v)
    } else {
      this.inMemory.set(k, v)
    }
  }
}

export const storage = new Storage()

export const setVideoCurrentTime = (url: string, time: number) => {
  storage.set(`contester:vct:${url}`, `${time}`)
}
export const getVideoCurrentTime = (url: string) => {
  return storage.get(`contester:vct:${url}`)
}
export const setVideoMuted = (experienceId: string, muted: boolean) => {
  storage.set(`contester:muted:${experienceId}`, `${muted}`)
}
export const getVideoMuted = (experienceId: string) => {
  return storage.get(`contester:muted:${experienceId}`) === 'true'
}